export const cities = [
  { name: "London", placeId: "ChIJdd4hrwug2EcRmSrV3Vo6llI" },
  { name: "Glasgow", placeId: "ChIJ685WIFYViEgRHlHvBbiD5nE" },
  { name: "Sydney", placeId: "ChIJP5iLHkCuEmsRwMwyFmh9AQU" },
  { name: "Liverpool", placeId: "ChIJt2BwZIrfekgRAW4XP28E3EI" },
  { name: "Melbourne", placeId: "ChIJ90260rVG1moRkM2MIXVWBAQ" },
  { name: "Manchester", placeId: "ChIJ2_UmUkxNekgRqmv-BDgUvtk" },
  { name: "Sheffield", placeId: "ChIJFb7o-qkKeUgReLAGr_UnKD4" },
  { name: "Birmingham", placeId: "ChIJc3FBGy2UcEgRmHnurvD-gco" },
];

export const defaultInventoryState = new Array(5).fill({
  id: 147635,
  name: "Bull Inn Court, London",
  pricing: {
    price: 2975,
    deposit: 250,
    currency: "pound",
    duration: "weekly",
  },
  videos: [
    {
      path: "v1669143802/inventories/oq4ebswajdrmoo01r7ti.mp4",
      type: "tour",
      caption: "Bull Inn Court",
      platform: "cloudinary",
      description: "Bull Inn Court, Video Tour\n",
      thumbnail_url:
        "https://res.cloudinary.com/amberstudent/video/upload/c_limit,h_60,w_90/v1669143802/inventories/oq4ebswajdrmoo01r7ti.jpg",
    },
  ],
  location: {
    name: "14 Bull Inn Ct",
    route: {
      long_name: "Bull Inn Court",
      short_name: "Bull Inn Ct",
    },
    state: {
      long_name: "England",
      short_name: "England",
    },
    country: {
      long_name: "United Kingdom",
      short_name: "GB",
    },
    primary: "14 Bull Inn Ct",
    district: {
      long_name: "Greater London",
      short_name: "Greater London",
    },
    locality: {
      long_name: "London",
      short_name: "London",
    },
    secondary: "London, UK",
    street_number: {
      long_name: "14",
      short_name: "14",
    },
    location_bounds: {
      northeast: {
        lat: 51.51188028029149,
        lng: -0.121798319708498,
      },
      southwest: {
        lat: 51.50918231970849,
        lng: -0.124496280291502,
      },
    },
    location_place_id:
      "EhoxNCBCdWxsIElubiBDdCwgTG9uZG9uLCBVSyIwEi4KFAoSCYv6_fnLBHZIEe7uxR6Ih94JEA4qFAoSCbV2A_rLBHZIEdHCqKocYyxG",
    location_coordinates: {
      lat: 51.5105313,
      lng: -0.1231473,
    },
  },
  tags: ["Air Conditioning", "bills_included", "Private elevator access", "not_available"],
  canonical_name: "bull-inn-court-1912063755522",
  status: "active",
  virtual_views: [],
  children_count: 1,
  reviews_rating: null,
  reviews_count: 0,
  inventory_featured_image_path: null,
  images_with_featured: [
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3858be18.jpg",
      type: "bedroom",
      caption: "Bedroom",
      featured: true,
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3858be18.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a190e951.jpg",
      type: "kitchen",
      caption: "Kitchen",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a190e951.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a517fe0b.jpg",
      type: "kitchen",
      caption: "Kitchen",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a517fe0b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3b3aa3b2.jpg",
      type: "kitchen",
      caption: "Kitchen",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3b3aa3b2.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4ddbb1c3.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4ddbb1c3.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/9e2ee740.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/9e2ee740.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/746149db.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/746149db.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/323b74a5.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/323b74a5.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/90685abc.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/90685abc.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4fc31088.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4fc31088.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8368c95b.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8368c95b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/d9c7c38b.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/d9c7c38b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/70758998.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/70758998.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2e59ec75.jpg",
      type: "amenities",
      caption: "Amenities",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2e59ec75.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8802784a.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8802784a.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/b611a530.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/b611a530.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/eff71b69.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/eff71b69.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/14be8daa.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/14be8daa.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2a4ce2d1.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2a4ce2d1.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/ad30e0d4.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/ad30e0d4.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/6cae8cbe.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/6cae8cbe.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/7f9c53df.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/7f9c53df.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3a98c881.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3a98c881.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/e02a1868.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/e02a1868.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/98130a0b.jpg",
      type: "floor_plan",
      caption: "Floor Plan",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/98130a0b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3ea06774.jpg",
      type: "exterior",
      caption: "Exterior",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3ea06774.jpg",
    },
  ],
  images: [
    {
      path: "https://assets.amberstudent.com/inventories/147635/3858be18.jpg?w=400&h=260&fit=crop&q=0&auto=format&trim=auto",
      type: "bedroom",
      caption: "Bedroom",
      featured: true,
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3858be18.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a190e951.jpg",
      type: "kitchen",
      caption: "Kitchen",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a190e951.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a517fe0b.jpg",
      type: "kitchen",
      caption: "Kitchen",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/a517fe0b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3b3aa3b2.jpg",
      type: "kitchen",
      caption: "Kitchen",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3b3aa3b2.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4ddbb1c3.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4ddbb1c3.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/9e2ee740.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/9e2ee740.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/746149db.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/746149db.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/323b74a5.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/323b74a5.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/90685abc.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/90685abc.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4fc31088.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/4fc31088.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8368c95b.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8368c95b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/d9c7c38b.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/d9c7c38b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/70758998.jpg",
      type: "common_area",
      caption: "Common Area",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/70758998.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2e59ec75.jpg",
      type: "amenities",
      caption: "Amenities",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2e59ec75.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8802784a.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/8802784a.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/b611a530.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/b611a530.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/eff71b69.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/eff71b69.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/14be8daa.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/14be8daa.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2a4ce2d1.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/2a4ce2d1.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/ad30e0d4.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/ad30e0d4.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/6cae8cbe.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/6cae8cbe.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/7f9c53df.jpg",
      type: "bedroom",
      caption: "Bedroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/7f9c53df.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3a98c881.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3a98c881.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/e02a1868.jpg",
      type: "bathroom",
      caption: "Bathroom",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/e02a1868.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/98130a0b.jpg",
      type: "floor_plan",
      caption: "Floor Plan",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/98130a0b.jpg",
    },
    {
      path: "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3ea06774.jpg",
      type: "exterior",
      caption: "Exterior",
      base_path:
        "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/inventories/147635/3ea06774.jpg",
    },
  ],
  offers_count: 1,
});
